import { isTargetedStep } from "./types";
import type { TourConfig, TourStep } from "./types";

function validateSteps(steps: TourStep[], tourId: string, label: string): void {
    steps.forEach((step, i) => {
        if (isTargetedStep(step) && !step.target) {
            throw new Error(`Tour "${tourId}" ${label} step ${i} must have a non-empty target`);
        }
        if (!step.title) {
            throw new Error(`Tour "${tourId}" ${label} step ${i} must have a non-empty title`);
        }
    });
}

export function validateTourConfig(config: TourConfig): void {
    if (!config.id) {
        throw new Error("Tour config must have a non-empty id");
    }
    if (!config.steps || config.steps.length === 0) {
        throw new Error(`Tour "${config.id}" must have at least one step`);
    }

    // Validate main steps
    validateSteps(config.steps, config.id, "main");

    // Validate group steps
    if (config.groups) {
        for (const [groupName, groupSteps] of Object.entries(config.groups)) {
            if (!groupSteps || groupSteps.length === 0) {
                throw new Error(`Tour "${config.id}" group "${groupName}" must have at least one step`);
            }
            validateSteps(groupSteps, config.id, `group "${groupName}"`);
        }
    }

    // Validate that all onTimeoutGroup references point to existing groups
    const allSteps = [...config.steps, ...Object.values(config.groups ?? {}).flat()];
    for (const step of allSteps) {
        if (isTargetedStep(step) && step.onTimeoutGroup) {
            if (!config.groups?.[step.onTimeoutGroup]) {
                throw new Error(
                    `Tour "${config.id}" references group "${step.onTimeoutGroup}" in onTimeoutGroup, but no such group exists`,
                );
            }
        }
        if (isTargetedStep(step) && step.advanceWhenSelector) {
            try {
                document.querySelector(step.advanceWhenSelector);
            } catch {
                throw new Error(
                    `Tour "${config.id}" has an invalid advanceWhenSelector "${step.advanceWhenSelector}" — must be a valid CSS selector`,
                );
            }
        }
    }
}
